import { render, staticRenderFns } from "./QuickUser.vue?vue&type=template&id=67d50125&scoped=true"
import script from "./QuickUser.vue?vue&type=script&lang=js"
export * from "./QuickUser.vue?vue&type=script&lang=js"
import style0 from "./QuickUser.vue?vue&type=style&index=0&id=67d50125&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d50125",
  null
  
)

export default component.exports